import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  ticket = new BehaviorSubject<any>(null);
  ticket$ = this.ticket.asObservable();
  isCreatedScheduled = new BehaviorSubject<any>(null);
  isCreatedScheduled$ = this.isCreatedScheduled.asObservable();

  selectedEvent = new BehaviorSubject<any>(null);
  selectedEvent$ = this.selectedEvent.asObservable();

  bookTicket = new BehaviorSubject<any>(null);
  bookTicket$ = this.bookTicket.asObservable();
  ItemDeleted: EventEmitter<{}> = new EventEmitter();
  constructor() {}

  updateData(formValue: object): void {
    const currentValue = this.ticket.getValue();
    const newValue = { ...currentValue, ...formValue };
    this.ticket.next(newValue);
  }

  getSalesInfo() {
    return this.bookTicket.getValue()?.info;
  }

  getTotalPriceInCart() {
    let items = this.bookTicket.getValue()?.items || [];
    let discount = this.bookTicket.getValue()?.totalwithdiscount;
    if (!discount) {
      let price = 0;
      items.map((res: any) => {
        price = price + res.ticket.price * res.quantity;
      });
      return price;
    } else {
      return discount;
    }
  }

  getTotalQuantity() {
    let items = this.bookTicket.getValue()?.items || [];
    let sum = 0;
    items.map((res: any) => {
      sum = sum + res.quantity;
    });

    return sum;
  }
  updateBookTicket(formValue: object): void {
    const currentValue = this.bookTicket.getValue();
    const newValue = { ...currentValue, ...formValue };
    this.bookTicket.next(newValue);
  }

  resetTickets(): void {
    this.bookTicket.next([]);
  }

  deleteItem(item: any) {
    let items = this.bookTicket.getValue()?.items || [];
    const index = items.indexOf(item);
    items.splice(index, 1);
    this.updateBookTicket({ items });
    this.ItemDeleted.emit(item);
  }

  updateBookTicketItems(newItem: any): void {
    let items = this.bookTicket.getValue()?.items || [];
    const item = items.find(
      (x: any) =>
        x.schedule?.id === newItem.schedule?.id &&
        x.ticket.id === newItem.ticket.id
    );

    if (item) {
      if (newItem.quantity === 0) {
        const index = items.indexOf(item);
        items.splice(index, 1);
      }
      items = items.map((x: any) => {
        if (
          x.schedule?.id === newItem.schedule?.id &&
          x.ticket.id === newItem.ticket.id
        ) {
          return {
            ...x,
            ...newItem,
          };
        }
        return {
          ...x,
        };
      });
    } else {
      items.push(newItem);
    }
    this.updateBookTicket({ items });
  }
}
